import { useRouter } from 'next/router';

export default function useSignUpHref() {
  const router = useRouter();
  const searchParams = new URLSearchParams(
    router.query as Record<string, string>
  );

  let url = `${process.env.NEXT_PUBLIC_MAIN_WEB_URL}/sign-up`;

  if (searchParams.size > 0) {
    url += `?${searchParams.toString()}`;
  }

  return url;
}
